var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docPreview"},[_c('div',{ref:"Vidpreview",staticStyle:{"width":"100%","height":"calc(100vh - 90px)"},attrs:{"id":"Vidpreview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }